import type { CSSProperties } from 'react'
import { designTokens } from '@/shared/lib/design-tokens'
import { cn } from '@/shared/lib'

const benefits = [
  '600+ докладов, воркшопов и курсов про продукт, маркетинг, дизайн, нейросети, управление командой и не только',
  'Закрытый чат комьюнити',
  'Random coffee с возможностью фильтрации',
  'Анкеты участников',
]

const typographyStyle = (token: { size: string; lineHeight: string; weight: number }) => ({
  fontFamily: designTokens.typography.fontFamilies.primary,
  fontSize: token.size,
  lineHeight: token.lineHeight,
  fontWeight: token.weight,
})

const iconSize = designTokens.sizes.width.subscriptionBenefitIcon

export type PlanBenefitsListVariant = 'desktop' | 'mobile' | 'checkout'

export type PlanBenefitsListProps = {
  variant?: PlanBenefitsListVariant
  className?: string
}

export function PlanBenefitsList({ variant = 'desktop', className }: PlanBenefitsListProps) {
  const isMobile = variant === 'mobile'
  const isCheckout = variant === 'checkout'
  const containerStyle: CSSProperties = {
    background: designTokens.colors.background.glassStrong,
    borderRadius: designTokens.borders.radius.lg,
    backdropFilter: `blur(${designTokens.effects.blur.subscriptionBenefitCard})`,
    WebkitBackdropFilter: `blur(${designTokens.effects.blur.subscriptionBenefitCard})`,
    padding: isMobile
      ? `${designTokens.spacing.xxl} ${designTokens.spacing.md}`
      : isCheckout
        ? designTokens.spacing.lg
        : undefined,
  }

  const containerGap = isMobile
    ? designTokens.spacing.md
    : isCheckout
      ? designTokens.spacing.md
      : designTokens.spacing.lg

  const itemGap = isCheckout
    ? designTokens.spacing.xs
    : designTokens.spacing.subscriptionBenefitItemGap

  const itemColor = isCheckout
    ? designTokens.colors.text.black
    : designTokens.colors.text.graphiteSoft

  return (
    <div
      className={cn('flex h-full w-full flex-col', className)}
      style={{ ...containerStyle, gap: containerGap }}
    >
      <div
        style={{
          ...typographyStyle(designTokens.typography.body.mdSemibold),
          color: designTokens.colors.text.deep,
        }}
      >
        В подписке вам доступны:
      </div>
      <div
        className={cn('flex w-full flex-col', isCheckout ? 'flex-1 justify-between' : undefined)}
        style={{ gap: isCheckout ? undefined : itemGap }}
      >
        {benefits.map((text) => (
          <div
            key={text}
            className="flex w-full items-start"
            style={{ gap: designTokens.spacing.subscriptionBenefitIconGap }}
          >
            <span style={{ width: iconSize, height: iconSize }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={iconSize}
                height={iconSize}
                viewBox="0 0 18 18"
                fill="none"
                aria-hidden="true"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="17"
                  height="17"
                  rx={designTokens.borders.radius.subscriptionBenefitIcon}
                  fill={designTokens.colors.background.surface}
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="17"
                  height="17"
                  rx={designTokens.borders.radius.subscriptionBenefitIcon}
                  stroke={designTokens.colors.border.subscriptionBenefitIcon}
                  strokeWidth={designTokens.borders.widths.thin}
                />
                <path
                  d="M14 6L7.125 13L4 9.81818"
                  stroke={designTokens.colors.border.paymentSelected}
                  strokeWidth={designTokens.borders.widths.alertIcon}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span
              style={{
                ...typographyStyle(designTokens.typography.body.base),
                color: itemColor,
              }}
            >
              {text}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
